import { takeLatest, call, put, all } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import * as SnackbarAction from '../actions/snackbarAction';
import * as InvoiceVendorAction from '../actions/invoiceVendorAction';
import { getWalletLimit } from '../actions/landingPageAction';
import history from '../utils/history';

function* saveInvoiceDetails(action) {
  try {
    let submitResponse = null;
    const response = yield call(
      callApi,
      URLS.SAVE_INVOICE,
      'POST',
      action.payload,
      true,
    );
    if (action.isSubmit && response.res_data?.invoice?.invoice_id) {
      // const { res_data, res_str }
      submitResponse = yield call(callApi, URLS.SUBMIT_INVOICE, 'POST', {
        invoice_id: response.res_data?.invoice?.invoice_id,
      });
      const { res_data, res_str } = submitResponse;
      if (res_data?.show_invoice_fee_prompt) {
        yield put(
          InvoiceVendorAction.setInvoiceDetails({ ...res_data }, res_str),
        );
      } else {
        yield put(InvoiceVendorAction.setInvoiceDetails({}));
        // history.push('/invoice/myinvoice');
        // yield put(
        //   SnackbarAction.openSnackbar({
        //     message: response.res_str,
        //     type: 'success',
        //   }),
        // );
      }
    } else {
      yield put(InvoiceVendorAction.setInvoiceDetails({}));
      // history.push('/invoice/myinvoice');
    }
    yield put(getWalletLimit());
    yield put(
      SnackbarAction.openSnackbar({
        message: submitResponse ? submitResponse.res_str : response.res_str,
        type: 'success',
      }),
    );
    history.push(`/invoice/myinvoice?tab=${action.isSubmit ? 'All' : 'Saved'}`);
  } catch (error) {
    if (error?.data?.res_data?.show_invoice_fee_prompt) {
      yield put(getWalletLimit());
      yield put(
        InvoiceVendorAction.setInvoiceDetails(
          { ...error?.data?.res_data.invoice_data },
          error?.data?.res_str,
        ),
      );
    } else {
      yield put(
        SnackbarAction.openSnackbar({
          message: error.data.res_str,
          type: 'error',
        }),
      );
    }
  }
}

function* getInvoiceDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.SAVE_INVOICE,
      'GET',
      action.payload,
    );
    yield put(InvoiceVendorAction.setInvoiceDetails(response.res_data));
  } catch (error) {
    // console.log('error', error);
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* getVendorList() {
  try {
    const response = yield call(callApi, URLS.VENDOR_LIST, 'get');
    yield put(InvoiceVendorAction.setVendorList(response.res_data));
  } catch (error) {
    // yield put(InvoiceVendorAction.setVendorList(vendorList));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
function* getCurrencyList() {
  try {
    const response = yield call(callApi, URLS.ORG_CURRENCY, 'get');
    yield put(InvoiceVendorAction.setCurrencyList(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* getWorkflowDetails(action) {
  try {
    const { id, url, params } = action.payload;
    const apiUrl = Object.keys(params).length
      ? URLS[url]
      : `${URLS[url]}${id}/`;
    const workflowResponse = yield call(callApi, `${apiUrl}`, 'get', params);
    const stateSettingResponse = yield call(
      callApi,
      `${URLS.STATE_SETTING}${workflowResponse.res_data.current_state.state_setting_id}/`,
      'get',
      {},
    );
    yield put(
      InvoiceVendorAction.setInvoiceDetails({
        ...workflowResponse.res_data,
        stateSetting: stateSettingResponse.res_data,
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* workflowContainerAction(action) {
  const { payload, commentData, scheduleDateParam } = action;
  try {
    if (scheduleDateParam) {
      yield call(
        callApi,
        URLS.RESCHEDULE_PAYMENT,
        'POST',
        action.scheduleDateParam,
      );
    }
    const [workflowres] = yield all([
      call(callApi, URLS.WORKFLOW_ACTION, 'POST', payload),
      commentData && call(callApi, URLS.WORKFLOW_COMMENTS, 'POST', commentData),
    ]);
    if (workflowres.res_data?.show_invoice_fee_prompt) {
      yield put(getWalletLimit());
      yield put(
        InvoiceVendorAction.setInvoiceDetails(
          { ...workflowres.res_data },
          workflowres.res_str,
        ),
      );
    } else if (payload.otp) {
      yield put(getWalletLimit());
      yield put(InvoiceVendorAction.invoiceSubmitConfirmationAction(true));
    } else {
      yield put(InvoiceVendorAction.setInvoiceDetails({}));
      yield put(getWalletLimit());
      history.push('/invoice/myapproval?tab=Pending');
      yield put(
        SnackbarAction.openSnackbar({
          message: workflowres.res_str,
          type: 'success',
        }),
      );
    }
    // yield put(InvoiceVendorAction.setInvoiceDetails(response.res_data));
  } catch (error) {
    // console.log('rrrr', error);
    if (error?.data?.res_data?.show_invoice_fee_prompt) {
      yield put(getWalletLimit());
      yield put(
        InvoiceVendorAction.setInvoiceDetails(
          { ...error?.data?.res_data.invoice_data },
          error?.data?.res_str,
        ),
      );
    } else {
      yield put(
        SnackbarAction.openSnackbar({
          message: error.data.res_str,
          type: 'error',
        }),
      );
    }
  }
}

function* updateInvoiceDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.INVOICE_UPDATE,
      'POST',
      action.payload,
      true,
    );
    if (action.isSubmit && response.res_data?.invoice?.invoice_id) {
      yield call(callApi, URLS.SUBMIT_INVOICE, 'POST', {
        invoice_id: response.res_data?.invoice?.invoice_id,
      });
    }
    history.push(`/invoice/myinvoice?tab=${action.isSubmit ? 'All' : 'Saved'}`);
    yield put(InvoiceVendorAction.setInvoiceDetails({}));
    yield put(getWalletLimit());
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    if (error?.data?.res_data?.show_invoice_fee_prompt) {
      yield put(getWalletLimit());
      yield put(
        InvoiceVendorAction.setInvoiceDetails(
          { ...error?.data?.res_data.invoice_data },
          error?.data?.res_str,
        ),
      );
    } else {
      yield put(
        SnackbarAction.openSnackbar({
          message: error.data.res_str,
          type: 'error',
        }),
      );
    }
  }
}

export function* generateOTP() {
  try {
    const res = yield call(callApi, URLS.GENERATE_OTP, 'GET', {});
    yield put(
      SnackbarAction.openSnackbar({
        message: res.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    // console.log(`API failed - reset OTP`);
  }
}

export function* submitInvoice(action) {
  try {
    const res = yield call(
      callApi,
      URLS.SUBMIT_INVOICE,
      'POST',
      action.payload,
    );
    if (action.payload.otp) {
      yield put(getWalletLimit());
      yield put(InvoiceVendorAction.invoiceSubmitConfirmationAction(true));
    } else {
      history.push('/invoice/myinvoice?tab=All');
      yield put(getWalletLimit());
      yield put(
        SnackbarAction.openSnackbar({
          message: res.res_str,
          type: 'success',
        }),
      );
    }
  } catch (error) {
    if (error?.data?.res_data?.show_invoice_fee_prompt) {
      yield put(getWalletLimit());
      yield put(
        InvoiceVendorAction.setInvoiceDetails(
          { ...error?.data?.res_data.invoice_data },
          error?.data?.res_str,
        ),
      );
    } else {
      yield put(
        SnackbarAction.openSnackbar({
          message: error.data.res_str,
          type: 'error',
        }),
      );
    }
  }
}

export function* getWorkflowComments(action) {
  try {
    const res = yield call(
      callApi,
      URLS.WORKFLOW_COMMENTS,
      'GET',
      action.payload,
    );
    yield put(InvoiceVendorAction.setWorkflowComments(res.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* getS3Attachment(action) {
  try {
    const response = yield call(
      callApi,
      URLS.S3_ATTACHMENT,
      'POST',
      action.payload,
      true,
    );

    yield put(InvoiceVendorAction.setS3Attachment(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}
export function* getData(action) {
  const { s3Payload, ocrPayload, deletedFileIndex } = action;
  let s3Response;
  let ocrResponse;
  try {
    if (s3Payload) {
      s3Response = yield call(
        callApi,
        URLS.S3_ATTACHMENT,
        'POST',
        s3Payload,
        true,
      );
    }
    if (ocrPayload) {
      ocrResponse = yield call(
        callApi,
        URLS.ORC_PARSER,
        'POST',
        ocrPayload,
        true,
      );
    }
    yield put(
      InvoiceVendorAction.setData(
        s3Response?.res_data,
        ocrResponse?.res_data,
        deletedFileIndex,
      ),
    );
  } catch (error) {
    console.log('error', error);
    yield put(
      InvoiceVendorAction.setData(
        s3Response?.res_data || {},
        ocrResponse?.res_data || {},
        deletedFileIndex,
        error?.data?.res_str || '',
      ),
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}

export function* rescheduleInvoice(action) {
  try {
    const response = yield call(
      callApi,
      URLS.RESCHEDULE_PAYMENT,
      'POST',
      action.payload,
    );
    yield put(InvoiceVendorAction.rescheduleCancelSuccess('reschedule', true));
    yield put(
      SnackbarAction.openSnackbar({
        message: 'You have successfully rescheduled the date!',
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}

export function* cancelPayment(action) {
  try {
    const response = yield call(
      callApi,
      URLS.CANCEL_PAYMENT,
      'POST',
      action.payload,
    );
    yield put(InvoiceVendorAction.rescheduleCancelSuccess('cancel', true));
    yield put(getWalletLimit());
    yield put(
      SnackbarAction.openSnackbar({
        message: 'You have successfully cancelled the payment!',
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}

export function* invoiceBulkAction(action) {
  try {
    yield call(callApi, URLS.INVOICE_BULK, 'POST', action.payload);
    yield put(InvoiceVendorAction.invoiceBulkActionSuccess(true));
    yield put(
      SnackbarAction.openSnackbar({
        message: 'Bulk operation is in process. Kindly refresh the table.',
        type: 'success',
      }),
    );
    yield put(getWalletLimit());
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}

export function* invoiceSaga() {
  yield takeLatest('SAVE_INVOICE_DETAILS', saveInvoiceDetails);
  yield takeLatest('GET_VENDOR_LIST', getVendorList);
  yield takeLatest('GET_CURRENCY_LIST', getCurrencyList);
  yield takeLatest('GET_INVOICE_DETAILS', getInvoiceDetails);
  yield takeLatest('GET_WORKFLOW', getWorkflowDetails);
  yield takeLatest('WORKFLOW_CONTAINER_ACTION', workflowContainerAction);
  yield takeLatest('UPDATE_INVOICE', updateInvoiceDetails);
  yield takeLatest('GENERATE_INVOICE_OTP', generateOTP);
  yield takeLatest('SUBMIT_INVOICE', submitInvoice);
  yield takeLatest('GET_WORKFLOW_COMMENT', getWorkflowComments);
  yield takeLatest('GET_S3_ATTACHMENT', getS3Attachment);
  yield takeLatest('GET_DATA', getData);
  yield takeLatest('RESCHEDULE_PAYMENT', rescheduleInvoice);
  yield takeLatest('CANCEL_PAYMENT', cancelPayment);
  yield takeLatest('INVOICE_BULK_ACTION', invoiceBulkAction);
}
